/*
 *
 * OnboardingContainer constants
 *
 */

export const DEFAULT_ACTION = 'app/OnboardingContainer/DEFAULT_ACTION';

export const ENABLE_LOADER = `${DEFAULT_ACTION}/ENABLE_LOADER`;
export const DISABLE_LOADER = `${DEFAULT_ACTION}/DISABLE_LOADER`;

export const SIGNUP = 'signup';
export const LOGIN = 'login';
export const FORGOT_PASSWORD = 'forgot_password';
export const RESET_PASSWORD = 'reset_password';

export const DEFAULT_STATUS = 'DEFAULT_STATUS';
export const USER_DETAILS_COMPLETED = 'USER_DETAILS_COMPLETED';

export const ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND';
export const ACCOUNT_EXISTS = 'ACCOUNT_EXISTS';

export const UPDATE_FORM_STATUS = `${DEFAULT_ACTION}/UPDATE_FORM_STATUS`;
export const UPDATE_LOGIN_FORM = `${DEFAULT_ACTION}/UPDATE_LOGIN_FORM`;

export const CREATE_MERCHANT = `${DEFAULT_ACTION}/CREATE_MERCHANT`;
export const SAVE_USER_DETAILS = `${DEFAULT_ACTION}/SAVE_USER_DETAILS`;

export const UPDATE_MERCHANT_DETAILS = `${DEFAULT_ACTION}/UPDATE_MERCHANT_DETAILS`;
export const SAVE_MERCHANT_DETAILS = `${DEFAULT_ACTION}/SAVE_MERCHANT_DETAILS`;

export const AUTHENTICATE_EMAIL_USER = `${DEFAULT_ACTION}/AUTHENTICATE_EMAIL_USER`;
export const AUTHENTICATE_ALIAS = `${DEFAULT_ACTION}/AUTHENTICATE_ALIAS`;

export const GOOGLE_LOGIN = `${DEFAULT_ACTION}/GOOGLE_LOGIN`;
export const GOOGLE_SIGNUP = `${DEFAULT_ACTION}/GOOGLE_SIGNUP`;

export const RESET_DATA = `${DEFAULT_ACTION}/RESET_DATA`;

export const REDEEM_VOUCHER = `${DEFAULT_ACTION}/REDEEM_VOUCHER`;

export const VALIDATE_TOKEN_SUCCESS = `${DEFAULT_ACTION}/VALIDATE_TOKEN_SUCCESS`;

export const CREATE_MERCHANT_URL = {
  url: '/common/signup/password',
  method: 'POST',
};

export const UPDATE_MERCHANT_DETAILS_URL = {
  url: '/common/merchant/configure',
  method: 'POST',
};

export const CREATE_FRESHSALES_LEAD = {
  url: '/common/freshsales/create-lead',
  method: 'PUT',
};

export const AUTHENTICATE_EMAIL_USER_URL = {
  url: '/common/signin/2fa',
  method: 'POST',
};

export const AUTHENTICATE_ALIAS_URL = {
  url: '/common/alias/signin/2fa',
  method: 'POST',
};

export const GOOGLE_LOGIN_URL = {
  url: '/common/google/sigin/2fa',
  method: 'POST',
};

export const GOOGLE_SIGNUP_URL = {
  url: '/common/signup/google',
  method: 'POST',
};

export const VERIFY_LOGIN_OTP_URL = {
  url: '/common/signin/verify-otp',
  method: 'POST',
};
export const RESEND_LOGIN_OTP_URL = {
  url: '/common/signin/resend-otp?id=$id$',
  method: 'GET',
};

export const PARTNER_TERMS_URL = {
  url: '/common/partner/terms/$refCode$',
  method: 'GET',
};

export const CHECK_EMAIL_EXISTS_URL = {
  url: '/common/v2/signup/validate-email',
  method: 'POST',
};

export const SEND_SIGNUP_OTP_URL = {
  url: '/common/v2/signup/send-otp',
  method: 'POST',
};

export const SIGNUP_MERCHANT_URL = {
  url: '/common/v2/signup/complete',
  method: 'POST',
};

export const VERIFY_IMPORTS_URL = {
  url: '/signup',
  method: 'POST',
};

export const onboardingModalData = {
  [ACCOUNT_EXISTS]: {
    icon: 'PENDING',
    iconSize: 'lg',
    header: 'Account Exists',
    description: [
      'An account with this email already exists. It was created on date and on device.',
      'Do you want to continue with the same account?',
    ],
    buttonText: ['Yes, continue with same account', 'No, create a new account'],
  },
  [ACCOUNT_NOT_FOUND]: {
    icon: 'ACCOUNT_NOT_FOUND',
    header: 'No Account Found',
    description: [
      'This email is not registered with us. Create a new account to proceed. ',
    ],
    buttonText: ['Create Account', 'Cancel'],
  },
};

export const LEAD_SOURCE_ID_MAPPING = {
  Web: 9000254828,
  'Organic Search': 9000254829,
  Email: 9000254830,
  Phone: 9000254831,
  Chat: 9000254832,
  'Web Form': 9000254833,
  'Direct Connect': 9000254837,
  'Referral - Merchant': 9000254838,
  'Referral - Bank': 9000254839,
  'Referral - Partners': 9000254840,
  'Linkedin Campaign': 9000254841,
  Event: 9000258555,
  Inbound: 9000258556,
  'Sign Up': 9000274724,
  Subscription: 9000274725,
  'Facebook Ads': 9000274726,
  'Payout Direct': 9000274727,
  'Product Hunt': 9000274728,
  Drip: 9000274729,
  'Manual Upload': 9000321536,
  'Instant Settlements': 9000321789,
  'UPI Stack': 9000321840,
  'Solutions Lending': 9000322059,
  'Partner Benefits': 9000322071,
  'PG Page': 9000322139,
  'Payout Page': 9000322140,
  'BAV Page': 9000322141,
  'Shopify Page': 9000322142,
  'Solutions Insurance': 9000322157,
  'Partner Merchant Onboarding': 9000322242,
  'Subscriptions Page': 9000322250,
  'Autocollect Page': 9000322251,
  'Cashgram Page': 9000322252,
  'Marketplace Page': 9000322253,
  'Instant Refunds Page': 9000322254,
  'Woocommerce Page': 9000322255,
  'Magento Page': 9000322256,
  'Solutions Education': 9000322411,
  'Social Media': 9000322421,
  'UPI-Autopay': 9000322608,
  Outbound: 9000322676,
  'Home page': 9000322717,
  'icici bank referral': 9000322726,
  'global payouts lp': 9000322736,
  'yes bank referral': 9000322762,
  'ecommerce lp': 9000322769,
  'marketing campaigns': 9000322794,
  'payme donations covid': 9000322893,
  'hsr ebook': 9000322920,
  'shipway website': 9000322927,
  'easy split': 9000322940,
  'linkedin ads': 9000322945,
  'google ads': 9000322959,
  'payment links': 9000322960,
  'partner sign up': 9000322968,
  'PAN Verification Page': 9000322998,
  'accounts lp': 9000323006,
  'banking as a service': 9000323007,
  'payment forms': 9000323053,
  'Sharktank LP': 9000323064,
  sharktank: 9000323064,
  'aadhaar verification': 9000323115,
  tokenvault: 9000323073,
  softpos: 9000323089,
  'wix payment gateway': 9000323125,
  advances: 9000323139,
  'gstin verification': 9000323138,
};

export const LOGIN_BANNER = [
  {
    type: 'vendor',
    heading: 'Introducing Vendor \nPayments!',
    description:
      'Effortlessly manage all your account payables! Upload invoices, sync with Tally, customise approval workflows, pay, track invoices, and reconcile seamlessly!',
    buttonText: 'Know more',
    slideIndicator: true,
    link:
      'https://www.cashfree.com/vendor-payments/?source-action=Merchant-login&action=Vendor_Payments&button-id=Know_More',
  },
  {
    type: 'collections',
    heading: 'Provide flexible Buy \nNow Pay Later options',
    description:
      'Give your customers the widest range of Buy Now Pay Later options including Zestmoney, LazyPay, Simpl, EMI on debit & credit cards, cardless & more.',
    buttonText: 'Know more',
    slideIndicator: true,
    link:
      'https://www.cashfree.com/buy-now-pay-later/?source-action=Merchant-login&action=BNPL&button-id=Know_More',
  },
  {
    type: 'disbursal',
    heading: 'Introducing \n‘One Escrow’',
    description:
      'Your all-in-one trusted escrow service: instantly verify parties, sign custom agreements, manage escrow accounts, and ensure trusted transactions between buyer-seller with our SEBI-backed trustee!',
    buttonText: 'Know more',
    slideIndicator: true,
    link:
      'https://www.cashfree.com/escrow-account/?source-action=Merchant-login&action=escrow_account&button-id=Know_More',
  },
];

export const GOOGLE_PRIVACY_POLICY = 'https://policies.google.com/privacy';
export const GOOGLE_TERMS_OF_SERVICE = 'https://policies.google.com/terms';

export const TOGGLE_OTP_MODAL = `${DEFAULT_ACTION}/TOGGLE_OTP_MODAL`;
export const VERIFY_LOGIN_OTP = `${DEFAULT_ACTION}/VERIFY_LOGIN_OTP`;
export const STORE_ERROR_LOGIN = `${DEFAULT_ACTION}/STORE_ERROR_LOGIN`;
export const RESEND_LOGIN_OTP = `${DEFAULT_ACTION}/RESEND_OTP`;
export const CHECK_EMAIL_EXISTS = `${DEFAULT_ACTION}/CHECK_EMAIL_EXISTS`;
export const SET_SIGNUP_FIRST_STEP_DATA = `${DEFAULT_ACTION}/SET_SIGNUP_FIRST_STEP_DATA`;
export const SIGNUP_MERCHANT = `${DEFAULT_ACTION}/SIGNUP_MERCHANT`;
export const SEND_SIGNUP_OTP = `${DEFAULT_ACTION}/SEND_SIGNUP_OTP`;
export const VERIFY_IMPORTS = `${DEFAULT_ACTION}/VERIFY_IMPORTS`;

export const loginSignupErrorCode = {
  STEP2_INCOMPLETE: 'CFLOGIN001',
  USER_NOT_FOUND: 'CFLOGIN002',
  WRONG_PASSWORD: 'CFLOGIN003',
  NO_PASSWORD: 'CFLOGIN004',
  SIGNUP_COMPLETE: 'CFLOGIN005',
  USER_EXISTS: 'CFLOGIN006',
  RESET_PASSWORD: 'CFLOGIN007',
};

export const SIGNUP_TYPE = {
  PASSWORD: 'SIGN_UP_PASSWORD',
  GOOGLE: 'SIGN_UP_GOOGLE',
};

export const RECAPTCHA_FAILED_MESSAGE = 'reCAPTCHA failed';
